import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoCampaignsReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_campaigns" />
);

export default KlaviyoCampaignsReport;
